// Core Imports
import React from "react";
//import DatePicker from "react-datepicker";
//import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import {connect} from "react-redux";
import {ErrorMessage, Field, Form, Formik} from "formik";
import * as Yup from "yup";
// Custom Imports
import logo from "../../public/assets/images/logo.png";
import * as ACTIONS from "./../../store/actions";
import Spinner from "./../../components/Spinner/Spinner";
import axios from "./../../axios";
import {toast} from "react-toastify";
// Import Datepicker
import { DatePicker, DatePickerInput } from 'rc-datepicker';

// Import the default style
import 'rc-datepicker/lib/style.css';

const gender = [
    {value: "Male", label: "Male"},
    {value: "Female", label: "Female"},
];

// formik form validation
const formikValidateSchema = Yup.object().shape({
    first_name: Yup.string().required("First name is required."),
    last_name: Yup.string().required("Last name is required."),
    email: Yup.string().required("Email is required.").email(),
    contact_number: Yup.string().required("Contact number is required.").min(9, "Contact number should be 9 digits.").max(10, "Maximum 10 digits are allowed.").matches(/^(?:[1-9]\d*|0)$/, "Should not start with 0"),
    gender: Yup.string().required("Gender is required."),
    country_id: Yup.string().required("Country is required."),
    state: Yup.string().required("State/Province is required."),
    city: Yup.string().required("City is required."),
    date_of_birth: Yup.string().required("Date of Birth is required."),
    zip_code: Yup.string().required("Zip Code is required."),
    street_address: Yup.string().required("Street Address is required."),
    term_of_use: Yup.boolean().oneOf([true], "Must Accept Terms and Conditions"),
    photo: Yup.string().required(),
});

let dobDate = new Date();
dobDate.setFullYear(dobDate.getFullYear() - 12)

class TutorProfile extends React.Component {
    state = {
        showInput: false,
        disabled:false,
        dobValue: dobDate,
        profileImage: null,
        photo: null,
        errors: null,
        formSubmitting: false,
        formikInitialValues: null,
        countriesList: [],
        processingHttpRequest: false,
    };

    componentDidMount() {
        this.getFieldsDataFromAPI();
        const tutorData = this.props.tutor_signup_data;
        this.setState({
            formikInitialValues: tutorData.tutor_profile,
            photo: tutorData.tutor_profile.photo,
        });
    }

    getFieldsDataFromAPI = () => {
        this.setState({processingHttpRequest: true});
        axios
            .get("/get-country-list")
            .then((countriesRes) => {
                const countries = countriesRes.data.records.countries.map((el) => {
                    return {
                        value: el.id,
                        label: el.name,
                    };
                });
                this.setState({
                    countriesList: countries,
                });
            })
            .catch((err) => {
                console.log({err});
            });
    };

    dobValueChangedHandler = (date) => {
        this.setState((state) => {
            return {
                startDate: date,
            };
        });
    };

    profileImageChangeHandler = (file) => {
        console.log({file});
        let reader = new FileReader();
        reader.onloadend = () => {
            this.setState({
                profileimge: file,
                photo: reader.result,
            });
            this.props.tutor_signup_data.tutor_profile.photo = reader.result
        };
        if (file) {
            try {
                reader.readAsDataURL(file);
            } catch (e) {
                console.log("Error while reading image file", e)
            }
        } else {
            console.log("File doesnt exists")
        }
    };

    clearProfileImageHandler = () => {
        this.props.tutor_signup_data.tutor_profile.photo = null;
        this.setState((oldState) => {
            return {
                profileImage: null,
                photo: null,
            };
        });
    };

    clearErrorsHandler = () => {
        this.setState({errors: null});
    };

    formSubmitHandler = (data) => {
        console.log({data});
        data.photo = this.state.photo;
        this.setState({formSubmitting: true});
        const signUpData = {
            tutor_profile: data,
            school_profile: [],
            password: "",
            password_confirmation: "",
        };
        axios
            .post("/tutor/signup", signUpData)
            .then((res) => {
                console.log("tutor-signup == res = ", {res});
                const tutorErrors = res.data.errors.tutor_profile;
                if (
                    tutorErrors &&
                    (tutorErrors.email || tutorErrors.contact_number)
                ) {
                    window.scrollTo(0, 0);
                    this.setState((oldState) => {
                        return {
                            errors: tutorErrors,
                            formSubmitting: false,
                        };
                    });
                    return;
                } else {
                    const updateSignupData = {
                        ...this.props.tutor_signup_data,
                        "tutor_profile": data,
                    };
                    this.props.setTutorSignUpData(updateSignupData);
                    this.props.next();
                }
            })
            .catch((err) => {
                if (err.response) {
                    // client received an error response (5xx, 4xx)
                    console.log("Password Step Request - Error - Response")
                } else if (err.request) {
                    // client never received a response, or request never left
                    console.log("Password Step Request - Error - Request")

                } else {
                    // anything else
                    console.log("Password Step Request - Error - Else")
                }

                // Retry Request
                toast.error(err.message)
                console.log("student-signup == err = ", {err});
                this.setState({formSubmitting: false});
            });
    };

    render() {
        const {
            profileImage,
            photo,
            dobValue,
            formSubmitting,
            errors,
            formikInitialValues,
            countriesList,
        } = this.state;
        return (
            <React.Fragment>
                <div className="account-wrap signup">
                    <div className="logo">
                        <a href="javascript:void(0)" onClick={this.props.goToLogin}>
                            <img src={logo} alt=""/>
                        </a>
                    </div>
                    <div className="container position-relative">
                        <div className="row">
                            <div className="col-sm-7 offset-sm-5">
                                <div className="account-form-wrap form-signup">
                                    <div className="account-title">
                                        <h3>Create Tutor Profile</h3>
                                        <p>Personal Details</p>
                                    </div>
                                    {errors && (
                                        <div
                                            className="alert alert-danger alert-dismissible fade show pb-0"
                                            role="alert"
                                            style={{opacity: "0.7"}}
                                        >
                                            <ul>
                                                {Object.keys(errors).map((key) => (
                                                    <li key={key}>{errors[key][0]}</li>
                                                ))}
                                            </ul>
                                            <button
                                                type="button"
                                                className="close"
                                                data-dismiss="alert"
                                                aria-label="Close"
                                                onClick={this.clearErrorsHandler}
                                            >
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                    )}
                                    <Formik
                                        initialValues={
                                            this.props.tutor_signup_data.tutor_profile
                                        }
                                        validationSchema={formikValidateSchema}
                                        onSubmit={(data) => {
                                            this.formSubmitHandler(data);
                                        }}
                                    >
                                        {({
                                              values,
                                              errors,
                                              touched,
                                              isValid,
                                              setFieldTouched,
                                              setFieldValue,
                                          }) => (
                                            <Form>
                                                <div className="form-floating">
                                                    <div className="form-row">
                                                        {/* <div className="form-group col-sm-6">
                              <pre>{JSON.stringify(values, null, 2)}</pre>
                            </div> */}
                                                        <div className="form-group col-sm-6">
                                                            <label htmlFor="first_name">First Name*</label>
                                                            <Field
                                                                type="text"
                                                                className="form-control"
                                                                name="first_name"
                                                                id="first_name"
                                                            />
                                                            <span>
                                <i className="far fa-user"></i>
                              </span>
                                                            <ErrorMessage name="first_name">
                                                                {(msg) => (
                                                                    <span className="invalid-feedback d-block">
                                    {msg}
                                  </span>
                                                                )}
                                                            </ErrorMessage>
                                                        </div>
                                                        <div className="form-group col-sm-6">
                                                            <label htmlFor="last_name">Last Name*</label>
                                                            <Field
                                                                type="text"
                                                                className="form-control"
                                                                id="last_name"
                                                                name="last_name"
                                                            />
                                                            <span>
                                <i className="far fa-user"></i>
                              </span>
                                                            <ErrorMessage name="last_name">
                                                                {(msg) => (
                                                                    <span className="invalid-feedback d-block">
                                    {msg}
                                  </span>
                                                                )}
                                                            </ErrorMessage>
                                                        </div>
                                                    </div>
                                                    <div className="form-row">
                                                        <div className="form-group col-sm-6">
                                                            <label htmlFor="email">Email*</label>
                                                            <Field
                                                                type="email"
                                                                className="form-control"
                                                                id="email"
                                                                name="email"
                                                            />
                                                            <span>
                                <i className="far fa-envelope"></i>
                              </span>
                                                            <ErrorMessage name="email">
                                                                {(msg) => (
                                                                    <span className="invalid-feedback d-block">
                                    {msg}
                                  </span>
                                                                )}
                                                            </ErrorMessage>
                                                        </div>
                                                        <div className="form-group col-sm-6">
                                                            <label htmlFor="contact_number">
                                                                Contact Number*
                                                            </label>
                                                            <Field
                                                                type="text"
                                                                className="form-control"
                                                                id="contact_number"
                                                                name="contact_number"
                                                            />
                                                            <span>
                                <i className="fa fa-phone"></i>
                              </span>
                              <label>
                                    <span className="invalid-feedback d-block">e.g. (3211999700). Don't use country code</span>
                                </label>
                                                            <ErrorMessage name="contact_number">
                                                                {(msg) => (
                                                                    <span className="invalid-feedback d-block">
                                    {msg}
                                  </span>
                                                                )}
                                                            </ErrorMessage>
                                                        </div>
                                                    </div>
                                                    <div className="form-row">
                                                        <div className="form-group col-sm-6">
                                                            <label htmlFor="gender">Gender*</label>
                                                            <Select
                                                                className="form-control choosen-select"
                                                                options={gender}
                                                                value={gender.filter(obj => obj.value == values.gender)}
                                                                id="gender"
                                                                name="gender"
                                                                onChange={(value) =>
                                                                    setFieldValue("gender", value.value, true)
                                                                }
                                                                onBlur={() =>
                                                                    setFieldTouched("gender", true, true)
                                                                }
                                                            />
                                                            <span>
                                <i className="fa fa-venus-mars"></i>
                              </span>
                                                            <ErrorMessage name="gender">
                                                                {(msg) => (
                                                                    <span className="invalid-feedback d-block">
                                    {msg}
                                  </span>
                                                                )}
                                                            </ErrorMessage>
                                                        </div>
                                                        <div className="form-group col-sm-6">
                                                            <label htmlFor="country_id">Country*</label>
                                                            <Select
                                                                className="form-control choosen-select"
                                                                options={countriesList}
                                                                id="country_id"
                                                                name="country_id"
                                                                onChange={(value) => {
                                                                    console.log(value);
                                                                    setFieldValue(
                                                                        "country_id",
                                                                        value.value,
                                                                        true
                                                                    );
                                                                }}
                                                                onBlur={() =>
                                                                    setFieldTouched("country_id", true, true)
                                                                }
                                                                value={countriesList.filter(obj => obj.value == values.country_id)}
                                                            />
                                                            <span>
                                <i className="fa fa-globe"></i>
                              </span>
                                                            <ErrorMessage name="country_id">
                                                                {(msg) => (
                                                                    <span className="invalid-feedback d-block">
                                    {msg}
                                  </span>
                                                                )}
                                                            </ErrorMessage>
                                                        </div>
                                                    </div>
                                                    <div className="form-row">
                                                        <div className="form-group col-sm-6">
                                                            <label htmlFor="state">State/Province*</label>
                                                            <Field
                                                                type="text"
                                                                className="form-control"
                                                                name="state"
                                                            />
                                                            <span>
                                <i className="far fa-map"></i>
                              </span>
                                                            <ErrorMessage name="state">
                                                                {(msg) => (
                                                                    <span className="invalid-feedback d-block">
                                    {msg}
                                  </span>
                                                                )}
                                                            </ErrorMessage>
                                                        </div>
                                                        <div className="form-group col-sm-6">
                                                            <label htmlFor="city">City*</label>
                                                            <Field
                                                                type="text"
                                                                className="form-control"
                                                                id="city"
                                                                name="city"
                                                            />
                                                            <span>
                                <i className="far fa-building"></i>
                              </span>
                                                            <ErrorMessage name="city">
                                                                {(msg) => (
                                                                    <span className="invalid-feedback d-block">
                                    {msg}
                                  </span>
                                                                )}
                                                            </ErrorMessage>
                                                        </div>
                                                    </div>
                                                    <div className="form-row">
                                                        <div className="form-group col-sm-6">
                                                            <label htmlFor="street_address">
                                                                Street Address*
                                                            </label>
                                                            <Field
                                                                type="text"
                                                                className="form-control"
                                                                id="street_address"
                                                                name="street_address"
                                                            />
                                                            <span>
                                <i className="fa fa-map-marker-alt"></i>
                              </span>
                                                            <ErrorMessage name="street_address">
                                                                {(msg) => (
                                                                    <span className="invalid-feedback d-block">
                                    {msg}
                                  </span>
                                                                )}
                                                            </ErrorMessage>
                                                        </div>
                                                        <div className="form-group col-sm-6">
                                                            <label htmlFor="zip_code">Zip Code*</label>
                                                            <Field
                                                                type="text"
                                                                className="form-control"
                                                                id="zip_code"
                                                                name="zip_code"
                                                            />
                                                            <span>
                                <i className="fa fa-map-marked-alt"></i>
                              </span>
                                                            <ErrorMessage name="zip_code">
                                                                {(msg) => (
                                                                    <span className="invalid-feedback d-block">
                                    {msg}
                                  </span>
                                                                )}
                                                            </ErrorMessage>
                                                        </div>
                                                    </div>
                                                    <div className="form-row">
                                                        <div className="form-group col-sm-6">
                                                            <label
                                                                htmlFor="date_of_birth"
                                                                className="d-block"
                                                            >
                                                                Date of Birth*
                                                            </label>
                                                            {/*<Field type="text" />*/}
                                                            <DatePickerInput
                                                                showInput={this.state.showInput}
                                                                disabled={this.state.disabled}
                                                                id="date_of_birth"
                                                                name="date_of_birth"
                                                                disabled={this.state.disabled}
                                                                displayFormat='DD-MM-YYYY'
                                                                returnFormat='YYYY-MM-DD'
                                                                defaultValue={dobValue}
                                                                maxDate={dobValue}
                                                                showOnInputClick
                                                                readOnly
                                                                className="form-control w-100 d-block datepicker"
                                                                onChange={(jsDate, dateString) => {
                                                                    console.log(jsDate);
                                                                    console.log(dateString);
                                                                    setFieldValue("date_of_birth", dateString, true);
                                                                    this.setState((oldState) => {
                                                                        return {
                                                                            dobValue: dateString,
                                                                        };
                                                                    });
                                                                }}
                                                            />
                                                            <span className="d-block">
                                <i className="fa fa-calendar-alt"></i>
                              </span>
                                                            <ErrorMessage name="date_of_birth">
                                                                {(msg) => (
                                                                    <span className="invalid-feedback d-block">
                                    {msg}
                                  </span>
                                                                )}
                                                            </ErrorMessage>
                                                        </div>
                                                        <div
                                                            className="form-group col-sm-6 custom-file-group"
                                                            onClick={() => {
                                                                document.getElementById("photo").click();
                                                            }}
                                                        >
                                                            <label htmlFor="photo">Photo or icon*</label>
                                                            <div className="form-control">
                                                                <input
                                                                    id="photo"
                                                                    name="photo"
                                                                    type="file"
                                                                    accept="image/jpeg,image/jpg"
                                                                    className="d-none"
                                                                    onChange={(event) => {
                                                                        const file = event.currentTarget.files[0];
                                                                        setFieldValue("photo", file, true);
                                                                        this.profileImageChangeHandler(file);
                                                                    }}
                                                                    ref={(el) => (this.profileImageElRef = el)}
                                                                    onBlur={() =>
                                                                        setFieldTouched("photo", true, true)
                                                                    }
                                                                />

                                                                {(values.photo) && "Profile Image Selected"}
                                                            </div>
                                                            <span>
                                <i className="far fa-images"></i>
                              </span>
                                                            {(values.photo) && (
                                                                <div className="file-help">
                                                                    <img src={(photo)} alt=""/>
                                                                    <div className="upload-requirements">
                                                                        <div className="dropdown">
                                                                            <a
                                                                                className=""
                                                                                type="button"
                                                                                id="dropdownMenuButton"
                                                                                data-toggle="dropdown"
                                                                                aria-haspopup="true"
                                                                                aria-expanded="false"
                                                                            >
                                                                                Upload Requirement
                                                                            </a>
                                                                            <div
                                                                                className="dropdown-menu dropdown-list"
                                                                                aria-labelledby="dropdownMenuButton"
                                                                            >
                                                                                <ul className="list-check-circle">
                                                                                    <li className="active">Only File
                                                                                    </li>
                                                                                    <li>64MB Limit</li>
                                                                                    <li>Allowed Types jpg, jpeg</li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <i className="far fa-question-circle"></i>
                                                                    <div
                                                                        className="delete-file"
                                                                        onClick={() => {
                                                                            this.clearProfileImageHandler();
                                                                            setFieldTouched("photo", true, true);
                                                                            setFieldValue("photo", "", true);
                                                                        }}
                                                                    >
                                                                        <img src={(values.photo)} alt=""/>
                                                                        <a>
                                                                            <i className="far fa-trash-alt"></i>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            <ErrorMessage name="photo">
                                                                {(msg) => (
                                                                    <span
                                                                        className="invalid-feedback d-block pl-4 ml-2">
                                    {msg}
                                  </span>
                                                                )}
                                                            </ErrorMessage>
                                                        </div>
                                                    </div>
                                                    <div className="form-row">
                                                        <div className="custom-control custom-checkbox">
                                                            <Field
                                                                type="checkbox"
                                                                className="custom-control-input"
                                                                id="term_of_use"
                                                                name="term_of_use"
                                                            />
                                                            <label
                                                                className="custom-control-label"
                                                                htmlFor="term_of_use"
                                                            >
                                                                I have read and accepted with the{" "}
                                                                <a
                                                                    href="https://schoolroomhelp.net/privacy-policy/"
                                                                    target="_blank"
                                                                >
                                                                    Privacy Policy
                                                                </a>
                                                            </label>
                                                            <ErrorMessage name="term_of_use">
                                                                {(msg) => (
                                                                    <span className="invalid-feedback d-block">
                                    {msg}
                                  </span>
                                                                )}
                                                            </ErrorMessage>
                                                        </div>
                                                    </div>
                                                    <div className="form-row">
                                                        {!formSubmitting && (
                                                            <button
                                                                type="submit"
                                                                disabled={!isValid || !photo}
                                                                className="btn btn-round btn-secondary"
                                                            >
                                                                LET ME CONTINUE
                                                            </button>
                                                        )}
                                                        {formSubmitting && <Spinner/>}
                                                    </div>
                                                    <div className="form-row f-size">
                                                        <em>
                                                            Already have an account?{" "}
                                                            <a href="javascript:void(0)" onClick={this.props.goToLogin}>
                                                                Login
                                                            </a>
                                                        </em>
                                                    </div>
                                                </div>
                                                {/* {profileImageURL &&
                          JSON.stringify(
                            { values, errors, touched, isValid },
                            null,
                            2
                          )} */}
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        tutor_signup_data: state.authR.tutor_signup_data,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setTutorSignUpData: (payload) =>
            dispatch(ACTIONS.setTutorSignupData(payload)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TutorProfile);
